module.exports = __webpack_public_path__ + "img/151.30d819b0.jpg";